"use client";
import { useModal } from "@/contexts/ModalContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BarChartCalendarGraph from "./BarChartCalendarGraph";
import SectionHeader from "./SectionHeader";
import Modal from "./ui/Modal";

export default function BarChartCalendar({
  data,
  origin,
  destination,
  departureCity,
  returnCity,
  title,
  description,
  currency,
}) {
  const t = useTranslationDetector();
  const infoModal = useModal("flight-price-chart-info-modal");

  const showTooltip = () => {
    infoModal.open({
      title: t("common.whatFlightPriceChartTitle"),
      isBottomSheet: true,
    });
  };

  return (
    <div className="container mx-auto w-full space-y-2 px-4 py-[21px] lg:space-y-10 lg:px-12 lg:py-15 xl:px-0">
      <SectionHeader title={title} description={description} />
      <div className="flex w-full flex-col items-start justify-center">
        <span className="items-center justify-start gap-1 text-base font-normal lg:flex">
          <span className="relative hidden items-center justify-start gap-1 md:flex">
            {t("common.flightPriceChartTitle")}
            <span className="group">
              <FontAwesomeIcon
                className="text-foreground-muted"
                icon={byPrefixAndName.far["circle-info"]}
              />
              <span className="absolute top-full left-0 z-50 hidden w-[317px] flex-col items-start justify-center pt-4 group-hover:flex">
                <span className="flex h-0 w-full items-center justify-center">
                  <span className="h-3 w-3 rotate-45 bg-white"></span>
                </span>
                <span className="relative block w-full rounded-lg bg-white p-4 shadow-lg">
                  {t("common.flightPriceChartDescription")}
                </span>
              </span>
            </span>
          </span>
          <button
            className="relative flex items-center justify-start gap-1 md:hidden"
            onClick={showTooltip}
          >
            {t("common.flightPriceChartTitle")}
            <FontAwesomeIcon
              className="text-foreground-muted"
              icon={byPrefixAndName.far["circle-info"]}
            />
          </button>
        </span>
        <BarChartCalendarGraph
          data={data}
          origin={origin}
          destination={destination}
          departureCity={departureCity}
          returnCity={returnCity}
          currency={currency}
        />
      </div>
      <Modal id="flight-price-chart-info-modal">
        {t("common.flightPriceChartDescription")}
      </Modal>
    </div>
  );
}
